/* Copier dans le presse-papier, partout.

   navigator.clipboard.writeText echoue dans trois cas au moins, et souvent
   EN SILENCE - le presse-papier garde son ancien contenu et on croit avoir
   copie :
     - hors contexte securise (page servie en http) : l'API n'existe pas ;
     - quand la page n'a pas le focus ;
     - quand l'appel suit un await : Firefox et Safari considerent que le geste
       de l'utilisateur est expire et refusent l'ecriture. C'est exactement le
       cas d'un bouton qui va d'abord chercher le lien au serveur.

   On retombe donc sur un champ temporaire et document.execCommand('copy'),
   qui n'a aucune de ces contraintes, et on dit franchement quand rien n'a pu
   etre copie plutot que de laisser croire au succes. */
export async function copierTexte(texte) {
  const valeur = String(texte == null ? '' : texte);
  if (!valeur) return false;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(valeur);
      return true;
    }
  } catch (e) { /* on tente la methode de repli */ }

  try {
    const zone = document.createElement('textarea');
    zone.value = valeur;
    zone.setAttribute('readonly', '');
    zone.style.position = 'fixed';
    zone.style.top = '-1000px';
    zone.style.opacity = '0';
    document.body.appendChild(zone);
    zone.focus();
    zone.select();
    zone.setSelectionRange(0, valeur.length);      /* iOS ignore select() seul */
    const ok = document.execCommand('copy');
    document.body.removeChild(zone);
    return ok;
  } catch (e) {
    return false;
  }
}

export default copierTexte;
